export default "__VITE_ASSET__JrjQprXn__"